const translations = {
  title: 'Criando apresentação de tela',
  title_edit: 'Editando apresentação de tela',
  title_cloning: 'Clonando apresentação de tela',
  name: 'Nome*',
  userGroups: 'Grupo de usuários',
  columnTitle: 'Criando coluna',
  columnTitle_edit: 'Editando coluna',
  columnTitle_cloning: 'Clonando coluna',
  color: 'Cor',
  filters: 'Filtros',
  widgetTitle: 'Adicionando widget',
  widgetTitle_edit: 'Editando widget',
  selectWidget: 'Selecione um widget'
}

export default translations
